var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfusedFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88623 28.1495C3.88623 14.2963 15.1164 3.06616 28.9696 3.06616C42.8227 3.06616 54.0529 14.2963 54.0529 28.1495C54.0529 42.0026 42.8227 53.2328 28.9696 53.2328C15.1164 53.2328 3.88623 42.0026 3.88623 28.1495ZM28.9696 6.56616C17.0494 6.56616 7.38623 16.2293 7.38623 28.1495C7.38623 40.0696 17.0494 49.7328 28.9696 49.7328C40.8897 49.7328 50.5529 40.0696 50.5529 28.1495C50.5529 16.2293 40.8897 6.56616 28.9696 6.56616Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1362 19.3995C38.1027 19.3995 38.8862 20.183 38.8862 21.1495V22.3162C38.8862 23.2827 38.1027 24.0662 37.1362 24.0662C36.1697 24.0662 35.3862 23.2827 35.3862 22.3162V21.1495C35.3862 20.183 36.1697 19.3995 37.1362 19.3995Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8029 19.3995C21.7694 19.3995 22.5529 20.183 22.5529 21.1495V22.3162C22.5529 23.2827 21.7694 24.0662 20.8029 24.0662C19.8364 24.0662 19.0529 23.2827 19.0529 22.3162V21.1495C19.0529 20.183 19.8364 19.3995 20.8029 19.3995Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8689 34.902C39.0056 35.8588 38.3407 36.7452 37.3839 36.8819L21.0506 39.2153C20.0938 39.3519 19.2074 38.6871 19.0707 37.7303C18.934 36.7735 19.5988 35.8871 20.5556 35.7504L36.889 33.4171C37.8458 33.2804 38.7322 33.9452 38.8689 34.902Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfusedFace);
export default __webpack_public_path__ + "static/media/confused-face.395beac0.svg";
export { ForwardRef as ReactComponent };